{
    "Profile_SideBar.policies": "FR: Policies",
    "Profile_SideBar.summary": "FR: Summary",
    "Profile_SideBar.renewal": "FR: Renewal",
    "Profile_SideBar.terms": "FR: Terms",
    "Profile_SideBar.underwriterCoverageAdjustment": "FR: Underwriting",
    "Profile_SideBar.liabilityExposure": "FR: Liability Exposure",
    "Profile_SideBar.policy": "FR: Policy",
    "Profile_SideBar.applicant": "FR: Insured",
    "Profile_SideBar.insuranceApplicant": "FR: Insurance Applicant",
    "Profile_SideBar.sn-commercial.business": "FR: Business Info",
    "Profile_SideBar.sn-commercial.insuranceHistory": "FR: Insurance History",
    "Profile_SideBar.sn-commercial.coverages": "FR: Coverages",
    "Profile_SideBar.sn-commercial.additionalInsureds": "FR: Additional Insureds",
    "Profile_SideBar.sn-commercial.lossPayees": "FR: Loss Payees",
    "Profile_SideBar.sn-commercial.employment": "Emploi",
    "Profile_SideBar.sn-commercial.memberships": "Adhésions",
    "Profile_SideBar.sn-small-business-insurance.business": "FR: Business Info",
    "Profile_SideBar.sn-small-business-insurance.insuranceHistory": "FR: Insurance History",
    "Profile_SideBar.sn-small-business-insurance.coverages": "FR: Coverages",
    "Profile_SideBar.sn-small-business-insurance.additionalInsureds": "FR: Additional Insureds",
    "Profile_SideBar.sn-small-business-insurance.lossPayees": "FR: Loss Payees",
    "Profile_SideBar.securemyoffer.secureMyOffer": "FR: Secure My Offer",
    "Profile_SideBar.securemyoffer.insuranceApplicant": "FR: Insurance Applicant",
    "Profile_SideBar.auto.drivers": "FR: Drivers",
    "Profile_SideBar.auto.vehicles": "FR: Vehicles",
    "Profile_SideBar.usauto.drivers": "FR: Drivers",
    "Profile_SideBar.usauto.vehicles": "FR: Vehicles",
    "Profile_SideBar.home.residents": "FR: Residents",
    "Profile_SideBar.home.dwellings": "FR: Dwellings",
    "Profile_SideBar.ushome.residents": "FR: Residents",
    "Profile_SideBar.ushome.dwellings": "FR: Dwellings",
    "Profile_SideBar.payment": "FR: Payment",
    "Profile_SideBar.documents": "FR: Documents",
    "Profile_SideBar.notes": "FR: Notes",
    "Profile_SideBar.history": "FR: History",
    "Profile_SideBar.logs": "FR: API Logs",
    "Profile_SideBar.securemyoffer.additionalSellers": "Vendeurs additionnels"
}
